import axios from "axios";
import { createTransactionID } from "../utils";

const win: any = window;
var token = window.location.href.includes("localhost") ? '8c21fcd0-59ca-4871-899c-aa0451870634' : win["clientToken"];
var errorPage = win["errorPageURL"];
const cem_key = window.location.href.includes("localhost") ? 'liCENcCCGpHUsEPHNhySYGXCnmhwzZ' : win["CEM_KEY"];

const apiBaseURL = window.location.href.includes("localhost") ? "https://apisit.mobily.com.sa/api" : win["base_api_url"];

let config = {
  api: {
    baseURL: apiBaseURL,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "",
      transactionId: createTransactionID(),
      channel: "PORTAL",
      "cem-key": cem_key
    },
  },
};

export const api = axios.create({ ...config.api });
export const simpleApi = axios.create();

api.defaults.validateStatus = function () {
  return true;
};

api.interceptors.request.use(
  async (conf: any) => {
    console.log("token : " + token);
    conf.headers.Authorization = "Bearer " + token;
    return conf;
  },
  (err) => {
    console.log("error in getting ", err);
  }
);

api.interceptors.response.use(
  async (response: any) => {
    return response;
  },
  async (error: any) => {
    if (!!errorPage) {
      document.location.href = errorPage;
    }
    return error;
  }
);

// get method

const getOrderType = async () => {
  return api.get(
    `${apiBaseURL}/digital/v1/data/mappings?contextId=CTX_B2B_ESALES&catalogKey=DIG_ESALES_ORDER_TYPES`
  );
};

const getNationalities = async () => {
  return api.get(
    `${apiBaseURL}/digital/v1/data/mappings?contextId=CTX_B2B_ESALES&catalogKey=SFA_NATIONALITIES`
  );
};

const getCities = async () => {
  return api.get(
    `${apiBaseURL}/digital/v1/data/mappings?contextId=CTX_B2B_ESALES&catalogKey=SFA_CITIES`
  );
};

const getProductType = async (catalogKey = 'DIG_ESALES_CAT') => {
  return api.get(
    `${apiBaseURL}/digital/v1/data/mappings?contextId=CTX_B2B_ESALES&catalogKey=${catalogKey}`
  );
};

const leadInquiry = (lead_id: string) => {
  return api.get(`${apiBaseURL}/b2b/utility/v1/sales/lead-inquiry`, {
    params: {
      lead_id
    }
  })
  // return api.get(`http://localhost:3001/leadInquiry`)


}

// post method

const sendOTP = (data: any) => {
  return api.post(`${apiBaseURL}/utility/v1/otp/send`, data);
};
const leadDetails = (data: any) => {
  return api.post(`${apiBaseURL}/b2b/utility/v1/sales/lead-inquiry`, data)
  //  return api.get(`http://localhost:3001/lead_details`);
}

// put method

const validateOTP = (data: any) => {
  return api.put(`${apiBaseURL}/utility/v1/otp/validate`, data);
};

const resendOTP = (data: any) => {
  return api.put(`${apiBaseURL}/utility/v1/otp/resend`, data);
};

const sendEmail = (data: any) => {
  const url = `${apiBaseURL}/utility/v1/notification`;

  return fetch(url, {
    method: 'PUT',
    headers: {
      "Authorization": `Bearer ${token}`,
      "cem-key": cem_key,
      "Content-Type": "application/json",
      channel: "PORTAL",
      referenceId: "SR_123hg87asfafF32"
    },
    body: JSON.stringify(data)
  });
};

const auditOTP = (hashKey: any) => {
  return api.get(`${apiBaseURL}/utility/v1/otp/status?referenceCode=${hashKey}`);
};

const salesAudit = (data: any) => {
  return api.put(`${apiBaseURL}/utility/v1/sales-audit`, data);
};

export { getOrderType, getProductType, leadDetails, leadInquiry, sendOTP, validateOTP, resendOTP, sendEmail, auditOTP, salesAudit, getCities, getNationalities };
